<div class="unactivated-page container-fluid">
  <div fxLayout="column" fxLayoutAlign="center center">
    <img src="/assets/images/faq-empty.png">
    <div class="mat-h2 title">Account not activated. Please contact Dynamoney to have it activated.</div>
    <button mat-flat-button color="primary" (click)="reLogin($event)">Re-login</button>
  </div>
</div>
